import { User } from "types/user";

//get coach + clients with first, last, and email in an array
export const GetAttendeeList = (coach: User, clients: User[]): string[] => {
    const list: string[] = [];
    list.push(`${coach.first_name} ${coach.last_name} <${coach.email}>`);

    list.concat(clients.map((x) => `${x.first_name} ${x.last_name} <${x.email}>`));


    return list;
};

//Get clients in a comma seperated string 
export const GetCommaSeperatedClientList = (user: User[], owningCoach: User): string => {
    if (user.length === 1) {
        return `${user[0].first_name} ${user[0].last_name}`;
    }

    const data = Array.from(user);
    const filteredUsers = data.filter(x => x.id !== owningCoach.id);

    const list: string = filteredUsers.map(x => `${x.first_name} ${x.last_name}`).join(", ");

    return list;
};

//Get list of all client first names
export const GetClientFirstNameList = (user: User[], owningCoach: User): string => {
    if (user.length === 1) {
        return `${user[0].first_name}`;
    }
    const data = Array.from(user);
    const list: string = (data.map((x) => {
        if (x.id !== owningCoach.id) {
            return `${x.first_name}`;
        }
    })).join(", >");

    return list;
};

//Get list of all client last names
export const GetClientLastNameList = (user: User[], owningCoach: User): string => {
    if (user.length === 1) {
        return `${user[0].last_name}`;
    }
    const data = Array.from(user);
    const list: string = (data.map((x) => {
        if (x.id !== owningCoach.id) {
            return `${x.last_name}`;
        }
    })).join(", >");

    return list;
};

//Get list of all client user names
export const GetClientUserNameList = (user: User[], owningCoach: User): string => {
    if (user.length === 1) {
        return `${user[0].username}`;
    }
    const data = Array.from(user);
    const list: string = (data.map((x) => {
        if (x.id !== owningCoach.id) {
            return `${x.username}`;
        }
    })).join(", >");

    return list;
};